import * as React from "react";
import { useOutletContext } from "react-router-dom";
import MobileDeclaration from "./components/mobile-declaration";
import WebDeclaration from "./components/web-declaration";

export default function Declaration() {

	const [handleChangeWebStyleLayout, layout] = useOutletContext();

	return (
		<React.Fragment>
			{layout === "mobile" 
				? <MobileDeclaration />
				: <WebDeclaration onChangeWebStyleLayout={handleChangeWebStyleLayout}/>
			}
		</React.Fragment>
	);
}
